<template>
  <div>
    <div>
      <div class="sixteentosix omt-6 omt-md-25 sixteentosix-wrap">
        <div class="new-background-wrap">
          <div
            class="kachelimage header-image zoom-image"
            style="
              background: url('/static/img/worldmap-1.jpg');
              background-position: top !important;
            "
          ></div>
          <!-- <img src="/static/img/video-main-banner.svg" /> -->
          <div class="headline-wrap">
            <div class="headline">
              <div class="text-subtitle-2 text-md-h5">
                {{ $t("target-revenue") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Breadcrumb />
    <div class="mx-0 row align-items-start">
      <div class="col-xl-9 px-8 pr-md-10 pr-lg-0">
        <div
          class="px-md-4 mx-0 row justify-content-center list-trainer-wrapper"
        >
          <div class="col-md-12 col-xl-12 d-flex justify-content-sm-between">
            <div class="col-md-12 col-xl-6 row g-space-15 mt-2">
              <div class="col-md-12 col-xl-4 p-0">
                <v-autocomplete
                  hide-details="auto"
                  :items="years"
                  class="datainput justify-content-end align-self-center pb-1"
                  dense
                  outlined
                  :label="$t('year')"
                  v-model="year"
                  @input="getTargetRevenues"
                ></v-autocomplete>
              </div>
              <div class="col-md-12 col-xl-6 p-0">
                <v-select
                  hide-details="auto"
                  :items="sortedCountries"
                  class="datainput justify-content-end align-self-center pb-1"
                  dense
                  outlined
                  :label="$t('country')"
                  @input="getTargetRevenues"
                  v-model="country"
                ></v-select>
              </div>
            </div>
            <v-btn
              @click="$router.push('/performance-board')"
              outlined
              depressed
              tile
              class="cancelBtn back-etc-wrap"
              ><v-icon>mdi-menu-left</v-icon>{{ $t("back") }}</v-btn
            >
          </div>
          <v-simple-table
            class="venuestable table-trainer-wrapper"
            style="width: 100%"
            hide-default-footer
          >
            <thead>
              <tr>
                <th
                  class="text-uppercase align-bottom venuestable-row table-trainer-wrapper-head"
                >
                  {{ $t("month") }}
                </th>
                <th
                  class="text-uppercase align-bottom venuestable-row table-trainer-wrapper-head"
                >
                  {{ $t("target_revenue") }}
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="venutable-row-border"
                v-for="targetrevenue in targetRevenues"
                :key="targetrevenue.id"
              >
                <td
                  class="pl-0 pb-1 text-uppercase align-center venutable-data"
                >
                  {{ $t(targetrevenue.month) }}
                </td>
                <td
                  class="pl-0 pb-1 text-uppercase align-center venutable-data"
                >
                  {{ validateAndFormatAmount(targetrevenue.targetvalue) }}
                </td>
                <td
                  class="pl-0 pb-1 text-uppercase align-center venutable-data"
                >
                  <template>
                    <v-btn
                      v-show="
                        $rights.includes('UPDATE_TARGET_REVENUE') &&
                        $user != null
                      "
                      color="transparent"
                      depressed
                      tile
                      v-bind="attrs"
                      v-on="on"
                      ><a
                        :href="
                          '/edit-target-revenue?trainer_target_revenue_id=' +
                          targetrevenue.id
                        "
                        ><img src="/static/img/pencil-new-img.svg" /></a
                    ></v-btn>
                  </template>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>
      </div>

      <!-- Right Area -->
      <div class="col-xl-3 pl-8 pl-md-12 pl-xl-8 row">
        <div
          class="col-xl-12 right-side-block"
          v-show="$rights.includes('CREATE_TARGET_REVENUE')"
        >
          <h4 class="text-uppercase">{{ $t("actions") }}</h4>
          <div class="right-side divider"></div>
          <div class="mt-6"></div>
          <v-btn
            :to="`/create-target-revenue`"
            v-show="$rights.includes('CREATE_TARGET_REVENUE')"
            outlined
            depressed
            tile
            class="savebutton mr-2"
            ><img
              class="list-trainer-img"
              src="/static/img/trainer-productivity-icon.svg"
            />{{ $t("create-target-revenue") }}</v-btn
          >
        </div>
        <Contact />
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "./Breadcrumbs.vue";

export default {
  components: {
    Breadcrumb,
  },
  data() {
    return {
      country: "GERMANY",
      countries: [],
      year: new Date().getFullYear(),
      rooms: [],
      years: [2024, 2025, 2026, 2026, 2027, 2028, 2029, 2030],
      targetRevenues: [],
      months_new: [
        "january",
        "february",
        "march",
        "april",
        "may",
        "june",
        "july",
        "august",
        "september",
        "october",
        "november",
        "december",
      ],
    };
  },
  computed: {
    sortedCountries() {
      return this.countries
        .map((country) => ({
          text: this.$t(country),
          value: country,
        }))
        .sort((a, b) => (a.text > b.text ? 1 : b.text > a.text ? -1 : 0));
    },
    months() {
      return [
        this.$t("january"),
        this.$t("february"),
        this.$t("march"),
        this.$t("april"),
        this.$t("may"),
        this.$t("june"),
        this.$t("july"),
        this.$t("august"),
        this.$t("september"),
        this.$t("october"),
        this.$t("november"),
        this.$t("december"),
      ];
    },
  },
  mounted() {
    this.getTargetRevenues();
    this.fetchCountries();
  },

  methods: {
    correctInputFormat(input) {
      input = input.toString();
      // If input is US-style (digits with a dot before 2 decimals), convert it
      const usStyleRegex = /^\d+(\.\d{1,2})?$/;
      if (usStyleRegex.test(input)) {
        return input.replace(/\./, ",");
      }

      // If input is US-style with thousand separators (e.g. 1,234.98)
      const usThousandStyleRegex = /^\d{1,3}(,\d{3})*(\.\d{1,2})?$/;
      if (usThousandStyleRegex.test(input)) {
        return input.replace(/,/g, "").replace(/\./, ",");
      }

      return input; // Return as-is if no match
    },
    validateAndFormatAmount(input) {
      if (!input) return "";
      console.log(input);
      // Fix US-style formats if detected
      input = this.correctInputFormat(input);

      // If already German-style, just append ,00 if needed
      const germanFormatRegex = /^\d{1,3}(\.\d{3})*(,\d{1,2})?$/;
      if (germanFormatRegex.test(input)) {
        return input.includes(",") ? input : `${input},00`;
      }

      // Standard number formatting
      let number = parseFloat(input.replace(/\./g, "").replace(",", "."));
      if (isNaN(number)) return input;

      return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(number);
    },
    fetchCountries() {
      this.$axios
        .get("/api/location/countries")
        .then((response) => {
          this.countries = response.data;
        })
        .catch(this.onError);
    },
    getTargetRevenues() {
      var _this = this;
      if (this.year != null) {
        this.$axios
          .get(
            "/api/target-revenue/get-data-by-year/" +
              this.year +
              "/" +
              this.country
          )
          .then(function (response) {
            _this.targetRevenues = response.data;
            for (var i = 0; i < response.data.length; i++) {
              _this.targetRevenues[i].month_value = response.data[i].month;

              _this.targetRevenues[i].month =
                _this.months_new[response.data[i].month];
            }
          })
          .catch(this.onError);
      }
    },
  },
};
</script>

<style scoped>
.v-dialog > .v-card > .v-card__actions {
  padding: 8px 16px;
}
</style>
